import React, { useEffect } from 'react';

import Loading from '@shared/components/loading/Loading';
import { APITokenModal } from '../integration-strategies/modal-strategy/templates/api-token';
import { toCancellable } from '../../../shared/axios';
import { useLojaIntegrada } from './loja-integrada.hooks';

export const LojaIntegrada = () => {
    const {
        loading,
        integrationData,
        submitting,
        loadInitialData,
        save,
    } = useLojaIntegrada();

    useEffect(() => toCancellable(loadInitialData()), [loadInitialData]);

    if (loading) return <Loading />;

    return (
        <APITokenModal
            onSubmit={save}
            initialData={{ apiToken: integrationData }}
            isSubmitting={submitting}
        />
    );
};
